import styled from 'styled-components';

export const SelectedBuildingsText = styled.div`
  font: 500 16px/19px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
`;

export const Container = styled.div<{ isRowList?: boolean }>`
  display: flex;
  flex-direction: row;
  /* Row cards sit closer than photo tiles do — the same 10px the plain list uses. */
  gap: ${({ isRowList }) => (isRowList ? '10px' : '24px')};
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const Grid = styled.div<{ isRowList?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isRowList }) => (isRowList ? '14px' : '24px')};
`;
